import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEnvelope,
    faToilet,
    faPaintRoller,
    faPenClip,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import labSocial from "../assets/LabSocial.jpeg";
import rinaShiftkey from "../assets/RinaShiftkey.jpg";
import "../scss/_hero.scss";

function Hero() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const animation = {
        initial: {
            opacity: 0,
            y: 100,
        },
        animate: {
            opacity: 1,
            y: 0,
            transform: "skewY(-3.5deg)",
        },
    };

    const handleReachOutClick = () => {
        navigate("/Career");
    };

    return (
        <div className="container">
            <div className="grid-container">
                <div className="writing">
                    <h1>{t("heroTitle")}</h1>
                    <p>{t("heroDescription")}</p>
                    <motion.button
                        className="reach-out-button"
                        whileHover={{ scale: 1.05 }}
                        onClick={handleReachOutClick} // Add onClick event
                    >
                        <FontAwesomeIcon className="icon" icon={faEnvelope} />
                        {t("reachOut")}
                    </motion.button>
                </div>
                <motion.div
                    className="first-image"
                    variants={animation}
                    initial="initial"
                    transition={{
                        delay: 0.45,
                    }}
                    whileInView="animate"
                    viewport={{
                        once: true,
                    }}
                >
                    <img alt={t("firstImageAlt")} src={rinaShiftkey} />
                </motion.div>
                <motion.div
                    className="second-image"
                    variants={animation}
                    initial="initial"
                    transition={{
                        delay: 0.7,
                    }}
                    whileInView="animate"
                    viewport={{
                        once: true,
                    }}
                >
                    <img alt={t("secondImageAlt")} src={labSocial} />
                </motion.div>
            </div>
            <div className="floating">
                <div id="research" className="float-icon">
                    <FontAwesomeIcon
                        className="floating-icon"
                        icon={faToilet}
                    />
                    <br />
                    <p>{t("research")}</p>
                </div>
                <div id="design" className="float-icon">
                    <FontAwesomeIcon
                        className="floating-icon"
                        icon={faPenClip}
                    />
                    <br />
                    <p>{t("design")}</p>
                </div>
                <div id="implementation" className="float-icon">
                    <FontAwesomeIcon
                        className="floating-icon"
                        icon={faPaintRoller}
                    />
                    <br />
                    <p>{t("implementation")}</p>
                </div>
            </div>
        </div>
    );
}

export default Hero;
